import { RedoSecondaryNavItem } from "@redotech/arbiter/navigation/secondary/redo-secondary-nav-item";
import { useRequiredContext } from "@redotech/react-util/context";
import { useTranslation } from "@redotech/redo-i18n";
import DashboardIcon from "@redotech/redo-icons/dashboard.svg";
import DashboardFilledIcon from "@redotech/redo-icons/dashboard_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { memo } from "react";

export const DashboardItems = memo(function DashboardItems() {
  const { t } = useTranslation();
  const routes = useRequiredContext(MerchantRoutesContext);

  return (
    <RedoSecondaryNavItem
      action={{ type: "link", href: routes.getConversionSubRoute("dashboard") }}
      FilledIcon={DashboardFilledIcon}
      friendlyName={t("Dashboard", {
        context: "checkout conversion navigation label",
      })}
      id="dashboard"
      UnfilledIcon={DashboardIcon}
    />
  );
});
